import { useUserRole } from '@/hooks/useUserRole.jsx'
import { RoleToWeight } from '@/consts/index.js'

export const useRoleGuard = (minimumRoleRequired, level) => {

    const userRole = useUserRole(level)

    const userRoleWeight = RoleToWeight[userRole] || 0
    const requiredRoleWeight = RoleToWeight[minimumRoleRequired] || 0

    return userRoleWeight >= requiredRoleWeight

}